export const SET_HOUSEHOLD_SHAPE = 'setHouseholdShape';
export const SET_IS_PARTNER_COAPPLICANT = 'setIsPartnerCoapplicant';
export const SET_PARTNER_FIRST_NAME = 'setPartnerFirstName';
export const SET_FORM_COMPLETED = 'setFormCompleted';
export const SAVE_HOUSEHOLD = 'saveHousehold';
export const CLEAR_HOUSEHOLD = 'clearHousehold';
